import dynamic from "next/dynamic";
import BaseHeaderConfig from "./base-header-config";
import BaseHeaderAdvancedConfig from "./base-header-advanced-config";
const BaseHeaderComponent = dynamic(()=>import("./base-header-component"));
export default {
    BaseHeaderComponent,
    BaseHeaderConfig,
    BaseHeaderAdvancedConfig
};
